import { apiFetch } from '@ami/react/core';
import { QuoteGroupFilter } from '../quote-groups/quoteGroupFilter';
import { QuoteGroupView } from '../quote-groups/quoteGroupView';

const _baseEndPoint = 'quote-groups';

const quoteGroupsServices = {
  search: async (filter = new QuoteGroupFilter(), page) => {
    filter.setPaginationParameters(page);
    const result = await apiFetch(`${_baseEndPoint}?${filter.toQueryString()}`);
    return result;
  },
  getView: async (id) => {
    const entity = await apiFetch(`${_baseEndPoint}/${id}`);
    return new QuoteGroupView(entity);
  },
  create: (input, automaticSuccessNotification = true) => {
    return apiFetch(_baseEndPoint, 'POST', input, {
      automaticSuccessNotification: automaticSuccessNotification,
    });
  },
  update: (input) => {
    return apiFetch(`${_baseEndPoint}/${input.id}`, 'PUT', input);
  },
  delete(id) {
    return apiFetch(`${_baseEndPoint}/${id}`, 'DELETE', null, {
      automaticSuccessNotification: false,
    });
  },
  associateQuote: (quoteGrouopId, quoteId) => {
    return apiFetch(
      `${_baseEndPoint}/${quoteGrouopId}/quote/${quoteId}`,
      'PUT'
    );
  },
  deAssociateQuote: (quoteGrouopId, quoteId) => {
    return apiFetch(
      `${_baseEndPoint}/${quoteGrouopId}/quote/${quoteId}`,
      'DELETE'
    );
  },
  editDealerContact(id, dealerContactId) {
    return apiFetch(
      `${_baseEndPoint}/${id}/dealer-contact`,
      'POST',
      { dealerContactId: dealerContactId },
      {
        automaticSuccessNotification: false,
      }
    );
  },
  async downloadPdf(quoteGrouopId) {
    const blob = await apiFetch(
      `${_baseEndPoint}/${quoteGrouopId}/pdf`,
      'GET',
      null,
      {
        contentType: 'application/pdf',
      }
    );
    return blob;
  },
  downloadCsv: (quoteGrouopId) => {
    return apiFetch(`${_baseEndPoint}/${quoteGrouopId}/csv`);
  },
};
export { quoteGroupsServices };
